import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '@/lib/hooks';
import styles from './NotFoundPage.module.css';

/**
 * Pagina 404 — allineata al riferimento (visual-diff pagine 31/07/2026,
 * voci 43/55/70/71): fondo crema #FBF9F4, contenuto centrato, «404» a 72px
 * navy con filetto azzurro, messaggio esteso nell'h2, testo 16px #1E3A5F,
 * riquadro bianco con «← Torna alla Home».
 *
 * L'h1 è il codice «404»: per uno screen reader il contesto lo dà l'h2
 * subito sotto («Pagina non trovata»), che resta il titolo del documento.
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  useDocumentTitle(t('error_404_title', 'Pagina non trovata'));

  return (
    <div className={styles.pagina}>
      <div className={`ic-container ${styles.wrapper}`}>
        <h1 className={styles.codice}>404</h1>
        <h2 className={styles.titolo}>{t('error_404_title', 'Pagina non trovata')}</h2>
        <p className={styles.testo}>
          {t('error_404_lead', 'La pagina che cercavi non esiste o è stata spostata.')}
        </p>
        <p className={styles.boxHome}>
          <Link to="/" className={styles.linkHome}>
            <span aria-hidden="true">← </span>
            {t('error_404_home', 'Torna alla Home')}
          </Link>
        </p>
      </div>
    </div>
  );
}
